<template>
    <div class="notice">
        欢迎您使用易售SUP系统，中控端地址为:管理端地址/admin,中控端拥有商品克隆，图片本地化，自动清理任务，供货商订单播报等扩展功能，后续的新功能也将添加于中控端。<br>
        感谢您选择易售SUP系统，如果发现BUG请您及时反馈，感谢您的支持。<br>
        相信易售SUP系统一定能给您带来不一样的全新体验<br>
    </div>
</template>
<script>
export default {
    name: 'NoticeView'
}
</script>
<style>
.notice {
    height: 100vh;
    width: 100vw;
    background-color: #353A40;
    color: white;
    font-size: 14px;
}
</style>